import { Component, OnInit } from '@angular/core';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { HeaderRowComponent } from "@shared/components/header-row/header-row.component";
import { AltExpansionPanelComponent } from "@shared/components/expansion-panel/alt-expansion-panel.component";
import { ExpenditureWorkflowsComponent } from "@shared/components/expenditure-workflows/expenditure-workflows.component";
import { MeetingOccuranceCardComponent } from "@modules/home/components/meeting-occurence-card/meeting-occurence-card.component";
import { MonitoringChecksCardComponent } from "@modules/home/components/monitoring-checks-card/monitoring-checks-card.component";
import { InactiveCasesCardComponent } from "@modules/home/components/inactive-cases-card/inactive-cases-card.component";
import { HeaderTitleComponent } from '@shared/components/header-row/header-title.component';
import { PageContentComponent } from '@shared/components/header-row/page-content.component';
import { PanelContentComponent } from '@shared/components/header-row/panel-content.component';

@Component({
    selector: 'cf2-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: [
        TranslocoPipe,
        HeaderRowComponent,
        HeaderTitleComponent,
        PageContentComponent,
        PanelContentComponent,
        AltExpansionPanelComponent,
        ExpenditureWorkflowsComponent,
        MeetingOccuranceCardComponent,
        MonitoringChecksCardComponent,
        InactiveCasesCardComponent,
        TranslocoDirective
    ],
})
export class HomeComponent implements OnInit {
  constructor(public transloco: TranslocoService) {
    console.log('🏠 HomeComponent constructor called');
  }

  ngOnInit() {
    console.log('🏠 HomeComponent ngOnInit called');
  }
}
